export const postForm = (url: string, data: object, method: string, target: string): void => {
  const wnd = window.open(
    method.toUpperCase() === 'GET' ? url : '',
    target,
    'popup=yes,scrollbars=yes,width=600,height=600'
  )
  if (wnd && data) {
    wnd.document.write(
      '<html lang="ru">' +
        '<head>' +
        '<title>Обработка платежа</title>' +
        '<script type="text/javascript">' +
        'function post(path, params, method) {' +
        ' method = method || "post";' +
        ' const form = document.createElement("form");' +
        ' form.setAttribute("method", method);' +
        ' form.setAttribute("action", path);' +
        ' for(let key in params) {' +
        '   if(params.hasOwnProperty(key)) {' +
        '     const hiddenField = document.createElement("input");' +
        '     hiddenField.setAttribute("type", "hidden");' +
        '     hiddenField.setAttribute("name", key);' +
        '     hiddenField.setAttribute("value", params[key]);' +
        '     form.appendChild(hiddenField);' +
        '   }' +
        ' }' +
        ' document.body.appendChild(form);' +
        ' form.submit();' +
        '}' +
        '</script>' +
        '</head>' +
        '<body>' +
        '<script type="text/javascript">' +
        'post("' +
        url +
        '", ' +
        JSON.stringify(data) +
        ',"' +
        method +
        '")' +
        '</script>' +
        '</body>' +
        '</html>'
    )
  }
}
